<template>
  <SvgUse/>  
  <main class="main start">
    <router-view />
  </main>
</template>



<script>
import SvgUse from '@/components/app/Use'



export default {
  name: 'StartLayout',

  components: {
    SvgUse
  },

  computed: {
    layoutType() {
      return this.$route.meta.type
    }
  }
}
</script>